import { useRef, useState, useEffect } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import DialogModal from "../DialogModal";

import {
  useGetDefaultLandingPage,
  useUpdateDefaultLandingPage,
} from "./clientDashboard.utils";

import { landingPageOptions } from "../../constants";
import { TooltipStandard } from "../Utility/TooltipStandard";

const renderTooltip = (message) => (props) =>
  (
    <TooltipStandard id="button-tooltip" {...props}>
      {message || "Landing Page on Login"}
    </TooltipStandard>
  );

function TogglePreviousLandingPage() {
  /**
   * @type {React.MutableRefObject<{show: function():void, hide: function():void} | null>} dialogModalRef
   */

  const dialogModalRef = useRef(null);
  const [defaultDashboard, setDefaultDashboard] = useState("dashboard");

  const { data: response, isLoading } = useGetDefaultLandingPage();
  const { mutate } = useUpdateDefaultLandingPage();

  const handleHideModal = () => {
    dialogModalRef.current?.hide();
    setDefaultDashboard((prev) =>
      prev === landingPageOptions.dashboard.value
        ? landingPageOptions.orderHistory.value
        : landingPageOptions.dashboard.value
    );
  };

  const handleConfirmModal = () => {
    if (!response?.data?.homePage) {
      mutate({
        HomePage:
          defaultDashboard === landingPageOptions.dashboard.value
            ? landingPageOptions.dashboard.value
            : landingPageOptions.orderHistory.value,
        isModified: false,
      });
      dialogModalRef.current?.hide();

      return;
    }

    mutate({
      HomePage:
        defaultDashboard === landingPageOptions.dashboard.value
          ? landingPageOptions.dashboard.value
          : landingPageOptions.orderHistory.value,
      isModified: true,
    });

    dialogModalRef.current?.hide();
  };

  useEffect(() => {
    if (!response?.data?.homePage) return;

    setDefaultDashboard(response?.data?.homePage);
  }, [response?.data]);

  return (
    <>
      <OverlayTrigger
        placement="top"
        overlay={renderTooltip(
          isLoading
            ? "Loading..."
            : `Landing Page: ${
                defaultDashboard ? "Dashboard" : "Order History"
              }`
        )}
      >
        <button
          className="tw-inline-flex tw-items-center tw-border-0 tw-bg-transparent tw-outline-none tw-cursor-pointer tw-p-0 focus:tw-outline-none"
          onClick={() => {
            // setDefaultDashboard((prev) => !prev);
            setDefaultDashboard((prev) =>
              prev === landingPageOptions.dashboard.value
                ? landingPageOptions.orderHistory.value
                : landingPageOptions.dashboard.value
            );

            dialogModalRef.current?.show();
          }}
          disabled={isLoading}
        >
          <span className="tw-mt-1 tw-mr-2">
            Landing Page:{" "}
            {defaultDashboard === landingPageOptions.dashboard.value
              ? "On"
              : "Off"}
          </span>
          <div className="custom-control custom-switch custom-switch-md tw-cursor-pointer">
            <input
              type="checkbox"
              className="custom-control-input tw-cursor-pointer tw-hidden"
              checked={defaultDashboard === landingPageOptions.dashboard.value}
              onChange={() => {}}
            />

            <label
              className="custom-control-label tw-cursor-pointer"
              htmlFor="toggle-previous-landing-page"
            />
          </div>
        </button>
      </OverlayTrigger>

      <DialogModal
        ref={dialogModalRef}
        title="Change Default Landing Page"
        onHide={handleHideModal}
        cancelButtonProps={{ onClick: handleHideModal }}
        saveButtonProps={{ onClick: handleConfirmModal }}
      >
        <p>
          Are you sure you want to change your default landing page to{" "}
          <strong>
            {defaultDashboard === landingPageOptions.dashboard.value
              ? "Dashboard"
              : "Order History"}
          </strong>
        </p>
      </DialogModal>
    </>
  );
}

export default TogglePreviousLandingPage;
